import { ContentItem, Fields } from 'kentico-cloud-delivery-typescript-sdk';

/**
 * This class was generated by 'kentico-cloud-model-generator-utility' module.
 * You can substitute instances of 'IContentItem' with a model defined in other class
 * to get access to all properties. This is applicable only if you know what item type the field contains.
 */
export class WideImage extends ContentItem {
    public image: Fields.AssetsField;
    
}


// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/wide_image.ts